// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3QjQW","flushRight":"footer-module--flushRight--32Qnc"};